const currencyFormat = (amount, symbol = '$') => {
  return `${symbol}${amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`;
};

export default currencyFormat;
